/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from 'axios'
import router from '@/router'
import { baseApiUrl } from '../../global'
export default {

  async fetchTotalLaborOrder({ commit }, payload) {

    try {
      payload.loading()
      const response = await axios.get(
        `${baseApiUrl}/laborOrder/getTotalLaborOrder`
      )
      payload.loading.close()
      commit('SET_TOTAL_LABOR_ORDER', response.data)
    } catch (error) {
      console.log(error)
    }finally{
      payload.loading.close()
    }
  },

  async fetchLaborOrder({ commit }, payload) {
    
    
    try {
      payload.loading()
      const response = await axios.get(
        `${baseApiUrl}/laborOrder/getLaborOrder?type=${payload.type}`
      )
      payload.loading.close()
      commit('SET_LABOR_ORDER', response.data)
    } catch (error) {
      console.log(error)
    }
  },


  async addNewLaborOrder({ commit }, payload) {
 
    try {
      payload.loading()
      let res = await axios.post(`${baseApiUrl}/laborOrder/save`, payload.order)
      payload.order.idLaborOrder = res.data
      delete payload.order.itemsOrder
      commit('ADD_NEW_LABOR_ORDER', payload.order)
      payload.loading.close()
      payload.notify({
        title: "Salvo",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success"
      })
    } catch (error) {
      console.log(error)
      payload.notify({
        title: "Erro",
        text: "Não foi possivel salvar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })
    }
    router.push(`/mao-de-obra`).catch(() => { });
  },



  async removeLaborOrder({ commit }, payload) {
    let idLaborOrder = payload.idOrder
    try {
      payload.loading()
      await axios.post(`${baseApiUrl}/laborOrder/remove`, { idLaborOrder })
      payload.loading.close()
      commit('REMOVE_LABOR_ORDER', idLaborOrder)
      payload.notify({
        title: "Removido",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success"
      })
    } catch (error) {
      console.log(error)
      payload.notify({
        title: "Erro",
        text: "Não foi possivel apagar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })
    }

  },


  async updateLaborOrder({ commit }, payload) {

    try {
      payload.loading()
      await axios.post(`${baseApiUrl}/laborOrder/update`, payload.order)
      delete payload.order.itemsOrder
      commit('UPDATE_LABOR_ORDER', payload.order)
      payload.loading.close()
      payload.notify({
        title: "Atualizado",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "primary"
      })
    } catch (error) {
      //console.log(error)
      payload.notify({
        title: "Erro",
        text: "Não foi possivel salvar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })
    }
    router.push(`/mao-de-obra`).catch(err => { });
  },

  async trashLaborOrder({ commit }, payload) {
    let idLaborOrder = payload.idOrder
    
    try {
      payload.loading() 
      await axios.post(
        `${baseApiUrl}/laborOrder/trash`,{ idLaborOrder }
      )
      payload.loading.close()
      commit('REMOVE_LABOR_ORDER', idLaborOrder)
      payload.notify({
        title: "Removido",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success"
      })
    } catch (error) {
      console.log(error)
      payload.notify({
        title: "Erro",
        text: "Não foi possivel apagar " + error,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "danger"
      })
    }
  },
  async fetchLaborOrderByPeriod({ commit }, payload) {
    try {
      payload.loading()
      const response = await axios.post(
        `${baseApiUrl}/laborOrder/getLaborOrderedByPeriod`,
        payload.data
      );
      payload.loading.close()
      commit('SET_LABOR_ORDER_FILTERED', response.data)
    } catch (error) {
      console.log(error);
      if (!error.response || !error.response.data) return;
      payload.notify({
        title: "Ocorreu algum problema",
        text: error.response.data,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "warning",
      });
      if (error.response.status == "400") {
        router.push("/mao-de-obra").catch(() => {});
      }
    } finally {
      payload.loading.close();
    }
  },

  async trashFilteredLaborOrder({ commit }, payload) {
    let idLaborOrder = payload.idOrder
    try {
      payload.loading() 
      await axios.post(
        `${baseApiUrl}/laborOrder/trash`,{ idLaborOrder }
      )
      payload.loading.close()
      commit('REMOVE_LABOR_ORDER_FILTERED', idLaborOrder)
      payload.notify({
        title: "Removido",
        text: "com Sucesso",
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "success"
      })
    } catch (error) {
      console.log(error);
      if (!error.response || !error.response.data) return;
      payload.notify({
        title: "Ocorreu algum problema",
        text: error.response.data,
        iconPack: "feather",
        icon: "icon-alert-circle",
        color: "warning",
      });
      if (error.response.status == "400") {
        router.push("/mao-de-obra").catch(() => {});
      }
    } finally {
      payload.loading.close();
    }
  },
}
